"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LedgerEntryDto = /** @class */ (function () {
    function LedgerEntryDto() {
    }
    return LedgerEntryDto;
}());
exports.default = LedgerEntryDto;
